import React, { Component, Fragment } from 'react';
import { translate } from '../Services/translation';
import constants from '../constants';
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import sv from 'date-fns/locale/sv';
registerLocale('sv', sv);

class LoadingDatePickerSelect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editingOrderType: {},
            editingTextField: {},
            modalIsOpen: false,
            accept: false,
            fromModalSubmitting: false,
            //startDate: this.props.
        };
    }

    handleDateChange(date) {
        //alert(date);
        this.setState({
            startDate: date
        });
        this.props.setLoadingDate(date);
    };

    render() {
        const { showPicker, loadingDateObject, togglePicker } = this.props;

        return ( 
            <Fragment>
                {loadingDateObject && loadingDateObject.loadingDateIsSet ? (
                    <a className="top-link__link--block" onClick={(event) => togglePicker()}>
                        <span className={`top-link__title loading-date-picker__date--is-set ${showPicker ? " top-link--active" : ""}`}><i className="icon fas fa-calendar-check"></i> <span className="loading-date-picker__delivery-date">{loadingDateObject.deliveryDisplayDateStr}</span> <b className="loading-date-picker__loading-date">{loadingDateObject.loadingDisplayDateStr}</b><b className="loading-date-picker__loading-date-short">{loadingDateObject.shortDateStr}</b></span>
                    </a>
                ) : (
                        <a className="top-link__link--block" onClick={(event) => togglePicker()}>
                            <span className={`top-link__title loading-date-picker__date--is-not-set ${showPicker ? " top-link--active" : ""}`}><i className="icon fas fa-calendar-check"></i><b className="loading-date-picker__loading-date">{translate('common.loadingdate.picker.title')}</b></span>
                        </a>
                    )}
                
                {showPicker &&
                    <div className={`loading-date-picker__picker ${!loadingDateObject || !loadingDateObject.loadingDateIsSet?' no-date-set':''}`}>
                        <DatePicker
                            selected={this.state.startDate || new Date(loadingDateObject.shortDateStr)}
                            onChange={date => this.handleDateChange(date)}
                            disabledKeyboardNavigation
                            showWeekNumbers
                            inline
                            dateFormat={constants.currentCultureDateFormat}
                            locale={constants.currentCultureName}
                        />
                    </div>
                }

            </Fragment>
        );

    }
}

export default LoadingDatePickerSelect;